import { render } from "./Registration.vue?vue&type=template&id=d79bf1c4&scoped=true&ts=true"
import script from "./Registration.ts?vue&type=script&lang=ts&external"
export * from "./Registration.ts?vue&type=script&lang=ts&external"

import "./Registration.scss?vue&type=style&index=0&id=d79bf1c4&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79bf1c4"]])

export default __exports__